<template>
	<v-row no-gutters justify="center">
		<v-col style="overflow: auto; height: 700px">
			<v-card v-if="cervical.value" class="ma-1 animated fadeIn" :color="cervical.color">
				<v-card-title class="pa-2 pb-0 text-body-1">Cervical</v-card-title>
				<v-card-text class="pa-2">
					<template v-if="cervical.value">
						<SegmentTest v-for="jointTest in test['cervical'].tests" :name="jointTest.name" :test="jointTest" :results="results" :key="jointTest.id" />
					</template>
				</v-card-text>
			</v-card>
			<v-card
				v-if="leftShoulder.value || rightShoulder.value"
				class="ma-1 animated fadeIn"
				:color="leftShoulder.color"
			>
				<v-card-title class="pa-2 pb-0 text-body-1">Ombro</v-card-title>
				<v-card-text class="pa-2">
					<v-row no-gutters>
						<span v-if="leftShoulder.value" v-translate>Left</span>
						<v-spacer></v-spacer>
						<span v-if="rightShoulder.value" v-translate>Right</span>
					</v-row>
					<v-divider class="my-1"></v-divider>
					<BilateralSegmentTest
						v-for="jointTest in test['shoulder'].tests"
						:key="jointTest.id"
						:name="jointTest.name"
						:showLeft="leftShoulder.value"
						:showRight="rightShoulder.value"
						:test="jointTest"
						:results="results"
					/>
				</v-card-text>
			</v-card>
			<v-card
				v-if="leftElbow.value || rightElbow.value"
				class="ma-1 animated fadeIn"
				:color="leftElbow.color"
			>
				<v-card-title class="pa-2 pb-0 text-body-1">Cotovelo</v-card-title>
				<v-card-text class="pa-2">
					<v-row no-gutters>
						<span v-if="leftElbow.value" v-translate>Left</span>
						<v-spacer></v-spacer>
						<span v-if="rightElbow.value" v-translate>Right</span>
					</v-row>
					<v-divider class="my-1"></v-divider>
					<BilateralSegmentTest
						v-for="jointTest in test['elbow'].tests"
						:key="jointTest.id"
						:name="jointTest.name"
						:showLeft="leftElbow.value"
						:showRight="rightElbow.value"
						:test="jointTest"
						:results="results"
					/>
				</v-card-text>
			</v-card>
			<v-card
				v-if="leftHand.value || rightHand.value"
				class="ma-1 animated fadeIn"
				:color="leftHand.color"
			>
				<v-card-title class="pa-2 pb-0 text-body-1">Punho/Mão</v-card-title>
				<v-card-text class="pa-2">
					<v-row no-gutters>
						<span v-if="leftHand.value" v-translate>Left</span>
						<v-spacer></v-spacer>
						<span v-if="rightHand.value" v-translate>Right</span>
					</v-row>
					<v-divider class="my-1"></v-divider>
					<BilateralSegmentTest
						v-for="jointTest in test['hand'].tests"
						:key="jointTest.id"
						:name="jointTest.name"
						:showLeft="leftHand.value"
						:showRight="rightHand.value"
						:test="jointTest"
						:results="results"
					/>
				</v-card-text>
			</v-card>
		</v-col>
		<v-col lg="8" md="7">
			<v-row no-gutters>
				<v-col cols="12">
					<v-row no-gutters justify="center" align="center">
						<v-btn-toggle v-model="yFilter">
							<v-btn value="superior" small class="text-overline">
								<translate>Superior</translate>
							</v-btn>
							<v-btn value="inferior" small class="text-overline">
								<translate>Inferior</translate>
							</v-btn>
						</v-btn-toggle>
						<v-btn-toggle v-model="xFilter" class="ml-2">
							<v-btn value="left" small class="text-overline">
								<translate>Left</translate>
							</v-btn>
							<v-btn value="right" small class="text-overline">
								<translate>Right</translate>
							</v-btn>
						</v-btn-toggle>
					</v-row>
				</v-col>
				<v-col cols="12">
					<OsteopathyFemaleBody
						v-if="gender == 'female'"
						:leftShoulder="leftShoulder"
						:rightShoulder="rightShoulder"
						:leftFoot="leftFoot"
						:rightFoot="rightFoot"
						:leftKnee="leftKnee"
						:rightKnee="rightKnee"
						:leftFemoral="leftFemoral"
						:rightFemoral="rightFemoral"
						:lowBack="lowBack"
						:dorsal="dorsal"
						:cervical="cervical"
						:leftElbow="leftElbow"
						:rightElbow="rightElbow"
						:leftHand="leftHand"
						:rightHand="rightHand"
					/>
					<OsteopathyMaleBody
						v-else
						:leftShoulder="leftShoulder"
						:rightShoulder="rightShoulder"
						:leftFoot="leftFoot"
						:rightFoot="rightFoot"
						:leftKnee="leftKnee"
						:rightKnee="rightKnee"
						:leftFemoral="leftFemoral"
						:rightFemoral="rightFemoral"
						:lowBack="lowBack"
						:dorsal="dorsal"
						:cervical="cervical"
						:leftElbow="leftElbow"
						:rightElbow="rightElbow"
						:leftHand="leftHand"
						:rightHand="rightHand"
					/>
				</v-col>
			</v-row>
		</v-col>
		<v-col style="overflow: auto; height: 700px">
			<v-card v-if="dorsal.value" class="ma-1 animated fadeIn" :color="dorsal.color">
				<v-card-title class="pa-2 pb-0 text-body-1">Dorsal</v-card-title>
				<v-card-text class="pa-2">
					<template v-if="dorsal.value">
						<SegmentTest v-for="jointTest in test['dorsal'].tests" :key="jointTest.id" :name="jointTest.name" :test="jointTest" :results="results" />
					</template>
				</v-card-text>
			</v-card>
			<v-card v-if="lowBack.value" class="ma-1 animated fadeIn" :color="lowBack.color">
				<v-card-title class="pa-2 pb-0 text-body-1">Lombar</v-card-title>
				<v-card-text class="pa-2">
					<template v-if="lowBack.value">
						<SegmentTest v-for="jointTest in test['lowback'].tests" :key="jointTest.id" :name="jointTest.name" :test="jointTest" :results="results" />
					</template>
				</v-card-text>
			</v-card>
			<v-card
				v-if="leftFemoral.value || rightFemoral.value"
				class="ma-1 animated fadeIn"
				:color="leftFemoral.color"
			>
				<v-card-title class="pa-2 pb-0 text-body-1">Coxo Femoral</v-card-title>
				<v-card-text class="pa-2">
					<v-row no-gutters>
						<span v-if="leftFemoral.value" v-translate>Left</span>
						<v-spacer></v-spacer>
						<span v-if="rightFemoral.value" v-translate>Right</span>
					</v-row>
					<v-divider class="my-1"></v-divider>
					<BilateralSegmentTest
						v-for="jointTest in test['femoral'].tests"
						:key="jointTest.id"
						:name="jointTest.name"
						:showLeft="leftFemoral.value"
						:showRight="rightFemoral.value"
						:test="jointTest"
						:results="results"
					/>
				</v-card-text>
			</v-card>
			<v-card
				v-if="leftKnee.value || rightKnee.value"
				class="ma-1 animated fadeIn"
				:color="leftKnee.color"
			>
				<v-card-title class="pa-2 pb-0 text-body-1">Joelho</v-card-title>
				<v-card-text class="pa-2">
					<v-row no-gutters>
						<span v-if="leftKnee.value" v-translate>Left</span>
						<v-spacer></v-spacer>
						<span v-if="rightKnee.value" v-translate>Right</span>
					</v-row>
					<v-divider class="my-1"></v-divider>
					<BilateralSegmentTest
						v-for="jointTest in test['knee'].tests"
						:key="jointTest.id"
						:name="jointTest.name"
						:showLeft="leftKnee.value"
						:showRight="rightKnee.value"
						:test="jointTest"
						:results="results"
					/>
				</v-card-text>
			</v-card>
			<v-card
				v-if="leftFoot.value || rightFoot.value"
				class="ma-1 animated fadeIn"
				:color="leftFoot.color"
			>
				<v-card-title class="pa-2 pb-0 text-body-1">Pé/Tornozelo</v-card-title>
				<v-card-text class="pa-2">
					<v-row no-gutters>
						<span v-if="leftFoot.value" v-translate>Left</span>
						<v-spacer></v-spacer>
						<span v-if="rightFoot.value" v-translate>Right</span>
					</v-row>
					<v-divider class="my-1"></v-divider>
					<BilateralSegmentTest
						v-for="jointTest in test['foot'].tests"
						:key="jointTest.id"
						:name="jointTest.name"
						:showLeft="leftFoot.value"
						:showRight="rightFoot.value"
						:test="jointTest"
						:results="results"
					/>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import SegmentTest from "@/components/appointment/tests/osteo/SegmentTest.vue";
import BilateralSegmentTest from "@/components/appointment/tests/osteo/BilateralSegmentTest.vue";
import OsteopathyFemaleBody from "@/components/appointment/tests/osteo/OsteopathyFemaleBody.vue";
import OsteopathyMaleBody from "@/components/appointment/tests/osteo/OsteopathyMaleBody.vue";

export default {
	name: "OsteopathyBody",
	props: ["test", "gender", "edit", "results"],
	components: {
		OsteopathyFemaleBody,
		OsteopathyMaleBody,
		SegmentTest,
		BilateralSegmentTest
	},
	data: () => ({
		yFilter: "",
		xFilter: "",
		leftShoulder: { value: false, color: "rgb(255,0,0,0.1)", selectable: true },
		rightShoulder: {
			value: false,
			color: "rgb(255,0,0,0.1)",
			selectable: true
		},
		leftFoot: { value: false, color: "rgb(0,0,255,0.1)", selectable: true },
		rightFoot: { value: false, color: "rgb(0,0,255,0.1)", selectable: true },
		leftKnee: { value: false, color: "rgb(255,255,0,0.1)", selectable: true },
		rightKnee: { value: false, color: "rgb(255,255,0,0.1)", selectable: true },
		leftFemoral: {
			value: false,
			color: "rgb(0,255,255,0.1)",
			selectable: true
		},
		rightFemoral: {
			value: false,
			color: "rgb(0,255,255,0.1)",
			selectable: true
		},
		lowBack: { value: false, color: "rgb(128,128,0,0.1)", selectable: true },
		dorsal: { value: false, color: "rgb(0,128,0,0.1)", selectable: true },
		cervical: { value: false, color: "rgb(0,255,0,0.1)", selectable: true },
		leftElbow: { value: false, color: "rgb(255,0,255,0.1)", selectable: true },
		rightElbow: { value: false, color: "rgb(255,0,255,0.1)", selectable: true },
		leftHand: { value: false, color: "rgb(128,0,128,0.1)", selectable: true },
		rightHand: { value: false, color: "rgb(128,0,128,0.1)", selectable: true }
	}),
	methods: {
		updateFilter() {
			this.resetFilters();
			if (this.xFilter == "left" && this.yFilter == "superior")
				this.setSuperiorLeft();
			else if (this.xFilter == "right" && this.yFilter == "superior")
				this.setSuperiorRight();
			else if (this.xFilter == "left" && this.yFilter == "inferior")
				this.setInferiorLeft();
			else if (this.xFilter == "right" && this.yFilter == "inferior")
				this.setInferiorRight();
			else if (this.xFilter == "left") this.setLeft();
			else if (this.xFilter == "right") this.setRight();
			else if (this.yFilter == "superior") this.setSuperior();
			else if (this.yFilter == "inferior") this.setInferior();
		},
		setSuperior() {
			this.selectSegment(this.leftShoulder);
			this.selectSegment(this.rightShoulder);
			this.selectSegment(this.lowBack);
			this.selectSegment(this.dorsal);
			this.selectSegment(this.cervical);
			this.selectSegment(this.leftElbow);
			this.selectSegment(this.rightElbow);
			this.selectSegment(this.leftHand);
			this.selectSegment(this.rightHand);
		},
		setInferior() {
			this.selectSegment(this.leftFoot);
			this.selectSegment(this.rightFoot);
			this.selectSegment(this.leftKnee);
			this.selectSegment(this.rightKnee);
			this.selectSegment(this.leftFemoral);
			this.selectSegment(this.rightFemoral);
		},
		setLeft() {
			this.selectSegment(this.leftShoulder);
			this.selectSegment(this.leftFoot);
			this.selectSegment(this.leftKnee);
			this.selectSegment(this.leftFemoral);
			this.selectSegment(this.leftElbow);
			this.selectSegment(this.leftHand);
		},
		setRight() {
			this.selectSegment(this.rightShoulder);
			this.selectSegment(this.rightFoot);
			this.selectSegment(this.rightKnee);
			this.selectSegment(this.rightFemoral);
			this.selectSegment(this.rightElbow);
			this.selectSegment(this.rightHand);
		},
		setSuperiorLeft() {
			this.selectSegment(this.leftShoulder);
			this.selectSegment(this.leftElbow);
			this.selectSegment(this.leftHand);
		},
		setSuperiorRight() {
			this.selectSegment(this.rightShoulder);
			this.selectSegment(this.rightElbow);
			this.selectSegment(this.rightHand);
		},
		setInferiorLeft() {
			this.selectSegment(this.leftFoot);
			this.selectSegment(this.leftKnee);
			this.selectSegment(this.leftFemoral);
		},
		setInferiorRight() {
			this.selectSegment(this.rightFoot);
			this.selectSegment(this.rightKnee);
			this.selectSegment(this.rightFemoral);
		},
		resetFilters() {
			this.deselectSegment(this.leftShoulder);
			this.deselectSegment(this.rightShoulder);
			this.deselectSegment(this.leftFoot);
			this.deselectSegment(this.rightFoot);
			this.deselectSegment(this.leftKnee);
			this.deselectSegment(this.rightKnee);
			this.deselectSegment(this.leftFemoral);
			this.deselectSegment(this.rightFemoral);
			this.deselectSegment(this.lowBack);
			this.deselectSegment(this.dorsal);
			this.deselectSegment(this.cervical);
			this.deselectSegment(this.leftElbow);
			this.deselectSegment(this.rightElbow);
			this.deselectSegment(this.leftHand);
			this.deselectSegment(this.rightHand);
		},
		setAllSegementsUnselectable() {
			this.leftShoulder.selectable = false;
			this.rightShoulder.selectable = false;
			this.leftFoot.selectable = false;
			this.rightFoot.selectable = false;
			this.leftKnee.selectable = false;
			this.rightKnee.selectable = false;
			this.leftFemoral.selectable = false;
			this.rightFemoral.selectable = false;
			this.lowBack.selectable = false;
			this.dorsal.selectable = false;
			this.cervical.selectable = false;
			this.leftElbow.selectable = false;
			this.rightElbow.selectable = false;
			this.leftHand.selectable = false;
			this.rightHand.selectable = false;
		},
		selectSegment(segment) {
			if (segment.selectable) segment.value = true;
		},
		deselectSegment(segment) {
			if (segment.selectable) segment.value = false;
		},
		selectAndSetSelectable(segment) {
			segment.value = true;
			segment.selectable = true;
		},
		selectSegmentsWithTests() {
			for (let jointCode in this.test) {
				for(let test in this.test[jointCode].tests) {
					if(this.test[jointCode].bilateral) {
						if(this.test[jointCode].tests[test].right.result != null) {
							switch (jointCode) {
								case 'shoulder':
									this.selectAndSetSelectable(this.rightShoulder);
									break;
								case 'elbow':
									this.selectAndSetSelectable(this.rightElbow);
									break;
								case 'femoral':
									this.selectAndSetSelectable(this.rightFemoral);
									break;
								case 'knee':
									this.selectAndSetSelectable(this.rightKnee);
									break;
								case 'foot':
									this.selectAndSetSelectable(this.rightFoot);
									break;
								case 'hand':
									this.selectAndSetSelectable(this.rightHand);
									break;
							}
						}
						if(this.test[jointCode].tests[test].left.result != null) {
							switch (jointCode) {
								case 'shoulder':
									this.selectAndSetSelectable(this.leftShoulder);
									break;
								case 'elbow':
									this.selectAndSetSelectable(this.leftElbow);
									break;
								case 'femoral':
									this.selectAndSetSelectable(this.leftFemoral);
									break;
								case 'knee':
									this.selectAndSetSelectable(this.leftKnee);
									break;
								case 'foot':
									this.selectAndSetSelectable(this.leftFoot);
									break;
								case 'hand':
									this.selectAndSetSelectable(this.leftHand);
									break;
							}
						}
					} else {
						if(this.test[jointCode].tests[test].result != null) {
							switch (jointCode) {
								case 'lowback':
									this.selectAndSetSelectable(this.lowBack);
									break;
								case 'dorsal':
									this.selectAndSetSelectable(this.dorsal);
									break;
								case 'cervical':
									this.selectAndSetSelectable(this.cervical);
									break;
							}
						}
					}
				}
			}
		},
		init() {
			this.resetFilters();
			if (this.results) {
				this.setAllSegementsUnselectable();
			}
			if (this.edit || this.results) {
				this.selectSegmentsWithTests();
			}
		},
		selectShoulder() {
			this.rightShoulder.value = true;
		}
	},
	watch: {
		yFilter() {
			this.updateFilter();
		},
		xFilter() {
			this.updateFilter();
		}
	},
	mounted() {
		console.log("MOUNTED");
		this.init();
	}
};
</script>

<style scoped>
.selectedJoint {
	fill: black !important;
}
.selectedJointOptions {
	display: block !important;
}
.selectedJointOption {
	fill: black !important;
	stroke: black !important;
}
.positive {
	fill: green !important;
}
.negative {
	fill: #ff3333 !important;
}
</style>